import Cookies from 'universal-cookie';
import * as DateHelpers from './DateHelpers';

const cookies = new Cookies();
const estTimeExtraHoursInstall = 0.66;
const estTimeExtraHoursDismantle = 0.34;

export function isLoggedIn() {
    var isAuth = cookies.get('da');

    if (!isAuth) {
        return false;
    }

    return true;
};

export function isNumeric(value: string) {
    return /^-{0,1}\d+$/.test(value);
}

export function calculateVoidEstimatedTime(useMin: boolean, quantity: number, size: number, people: number, voidSizeMin: number, voidFormulaMins: number, voidSizeExtraTime: number, scheduleType: number, extraHours: number) {
    var mins = 60 * voidFormulaMins;
    var sizeRate = size < voidSizeMin ? 0 : size - voidSizeMin;
    var sizeMins = sizeRate * voidSizeExtraTime;

    //add extra minutes based on the size of the void
    mins += sizeMins;

    //add extra time based on the number of people installing/dismantling the voids
    mins = people === 2 ? (mins * 3) / 2 : people === 1 ? mins * 3 : mins;    //calculate based on # people

    mins = quantity * mins;
    //add on extra hour minutes from calculation
    mins += CalculateExtraHoursMinutes(scheduleType, extraHours);

    if (useMin && mins < 20) {
        //added usemin as I don't want to do this when splitting job between multiple trucks with extra hours
        mins = 20;  //minimum time of 20 minutes
    }

    var hourmins = DateHelpers.convertMinsToHoursMinutes(mins);

    return hourmins;
}

export function calculateEstimatedTimeMins(quantity: number, people: number, formulaAmount: number, scheduleType: number, extraHours: number) {
    if (formulaAmount === 0 || people === 0) {
        return 0;
    }

    var mins = ((quantity / formulaAmount) * 60) * (3 / people)
    if (mins === 0) {
        return 0;
    }

    //add on extra hour minutes from calculation
    mins += CalculateExtraHoursMinutes(scheduleType, extraHours);

    if (mins < 20) {
        mins = 20;  //minimum time of 20 minutes
    }

    return mins;
}

export function calculateEstimatedTime(quantity: number, people: number, formulaAmount: number, scheduleType: number, extraHours: number) {
    var mins = calculateEstimatedTimeMins(quantity, people, formulaAmount, scheduleType, extraHours);
    var hourmins = DateHelpers.convertMinsToHoursMinutes(mins);

    return hourmins;
}

export function CalculateExtraHoursMinutes(scheduleType: number, extraHours: number)
{
    //If this is updated, also update the c# method in shared Generic
    //extra hours formula
    //Install: (ExtraHours * 60 * 0.6) * 0.66
    //Dismantle: (ExtraHours * 60 * 0.6) *0.34
    var formula = scheduleType === 1 ? estTimeExtraHoursInstall : scheduleType === 2 ? estTimeExtraHoursDismantle : 0;
    var extraMins = (extraHours * 60 * 0.6) * formula;
    var mins = extraMins;
    return mins;
}